/**
 * Lightweight skeleton shown while a route chunk is loading.
 * Mimics the app's general content layout so switching pages feels instant
 * instead of showing a blank spinner.
 */
export const PageSkeleton = () => {
  return (
    <div className="space-y-4 sm:space-y-6 animate-pulse" data-testid="page-skeleton">
      {/* Title bar */}
      <div className="flex items-center justify-between gap-3">
        <div className="space-y-2">
          <div className="h-7 w-48 rounded bg-slate-200" />
          <div className="h-4 w-64 rounded bg-slate-100" />
        </div>
        <div className="h-10 w-32 rounded bg-slate-200" />
      </div>

      {/* Filter card */}
      <div className="rounded-lg border border-slate-200 bg-white p-4 space-y-3">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[1, 2, 3, 4].map(i => (
            <div key={i} className="space-y-1">
              <div className="h-3 w-16 rounded bg-slate-100" />
              <div className="h-9 rounded bg-slate-200" />
            </div>
          ))}
        </div>
      </div>

      {/* Content card */}
      <div className="rounded-lg border border-slate-200 bg-white p-4 space-y-3">
        <div className="space-y-2.5">
          {[1, 2, 3, 4, 5, 6, 7].map(i => (
            <div key={i} className="grid grid-cols-12 gap-3">
              <div className="col-span-2 h-4 rounded bg-slate-100" />
              <div className="col-span-4 h-4 rounded bg-slate-200" />
              <div className="col-span-3 h-4 rounded bg-slate-100" />
              <div className="col-span-3 h-4 rounded bg-slate-200" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
